<template>
  <div>
    <section class="footer-section">
      <div class="container footer-inner">
        <div class="footer-top-pad">
          <b-row class="mt-5 footer-row">
            <b-col lg="4" md="12" sm="12" class="mb-4">
              <div class="footer-brand footer-stack">
                <div class="footer-logo-wrap">
                  <img
                    class="footer-logo"
                    width="170"
                    src="../../assets/images/footerLogo.png"
                    alt="Takhaty"
                  >
                </div>
                <p class="footer-tagline-text">
                  {{ langDec.footer_tagline }}
                </p>
                <div class="footer-social">
                  <b-button variant="link" href="https://www.instagram.com/takhatyconsulting/" class="footer-btn" target="_blank" rel="noopener noreferrer"><img width="25" src="../../../src/assets/images/instagram.png" alt="Instagram"></b-button>
                  <b-button variant="link" href="https://www.facebook.com/takhaty/" class="footer-btn" target="_blank" rel="noopener noreferrer"><img width="25" src="../../../src/assets/images/facebook.png" alt="Facebook"></b-button>
                  <b-button variant="link" href="https://x.com/takhatty" class="footer-btn" target="_blank" rel="noopener noreferrer"><img width="25" src="../../../src/assets/images/xapp.png" alt="X"></b-button>
                </div>
              </div>
            </b-col>

            <b-col lg="5" md="6" sm="12" class="my-2 footer-stack footer-col--links">
              <h5 class="footer-heading">{{ langDec.footer_main_links }}</h5>
              <b-row class="mt-4">
                <b-col lg="6" md="12" sm="12">
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('landingPage')">{{ langDec.nav_home }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('aboutUs')">{{ langDec.nav_about_takhaty }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('consultations')">{{ langDec.nav_consultations }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('articles')">{{ langDec.footer_blog_link }}</b-link>
                  </div>
                </b-col>
                <b-col lg="6" md="12" sm="12">
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('clubs')">{{ langDec.footer_club_link }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('contactus')">{{ langDec.nav_contact }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('termsAndConditions')">{{ langDec.footer_terms }}</b-link>
                  </div>
                  <div class="mt-3">
                    <b-link class="link footer-link" @click="goToRoute('privacyPolicy')">{{ langDec.footer_privacy }}</b-link>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col lg="3" md="6" sm="12" class="my-2 footer-stack footer-col--contact">
              <h5 class="footer-heading">{{ langDec.footer_contact_heading }}</h5>
              <b-row class="mt-4">
                <b-col lg="12" md="12" sm="12">
                  <div class="mt-3">
                    <p>
                      <b>{{ langDec.footer_email_label }}</b>
                      <br>
                      <b-link class="link footer-link" @click="gotomail('info@takhaty.com')">info@takhaty.com</b-link>
                    </p>
                  </div>
                  <div v-if="phone" class="mt-3">
                    <p>
                      <b>{{ langDec.footer_phone_label }}</b>
                      <br>
                      <b-link
                        class="link footer-link footer-phone-link"
                        :href="'tel:' + phone"
                      >{{ phone }}</b-link>
                    </p>
                  </div>
                  <div v-if="whatsapp" class="mt-3">
                    <p>
                      <b>{{ langDec.footer_whatsapp_label }}</b>
                      <br>
                      <b-link class="link footer-link" :href="'https://wa.me/' + whatsapp">{{ whatsapp }}</b-link>
                    </p>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>

      <hr class="footer-hr">

      <div class="container">
        <p class="footer-copyright">{{ langDec.footer_rights }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import store from "../../store/index.js"
import { sendRequest } from "../../utils/RequestHelper.js"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      isVisible: false,
      username: null,
      userImage: null,
      requestIsLoading: false,
      search: null,
      searchResults: [],
      phone: process.env.VUE_APP_PHONE,
      whatsapp: process.env.VUE_APP_WHATSAPPNUMBER
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {};
    },
  },
  watch: {
    $route() {
      this.username = this.$store.getters.username;
      this.userImage = this.$store.getters.getImage;
    }
  },
  methods: {
    gotomail(email) {
      window.open(`mailto:${email}`);
    },
    goToRoute(name) {
      this.$router.push({
        name,
      }).catch(()=>{});
    },

    searchMehtod(search) {
      this.$router.push({
        name: "search",
        params: {
          search
        }
      })
    },
    navToogle() {
      this.isVisible = !this.isVisible;
    },
    logout() {
      var successCallback = () => {
        store.dispatch("LOGOUT");
        this.$router.push({
          name: "landingPage"
        })
      };
      var errorCallback = () => {
      };
      sendRequest('post', '/admin/logout', true, {}, successCallback, errorCallback);
    }
  },
  created() {
    this.username = this.$store.getters.username;
    this.userImage = this.$store.getters.getImage;
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.footer-section {
  color: grey !important;
  background-image: url(../../assets/images/footerBG.webp);
  background-size: cover;
  background-position: right top;
  width: auto;
  color: white !important;
  margin: 0px;
}

.footer-inner {
  padding: 40px 10px;
}

.footer-stack {
  color: white;
  text-align: start;
  display: grid;
}

.footer-heading {
  color: white;
  font-weight: 700;
}

.footer-tagline-text {
  color: white;
  font-size: 18px;
  margin: 0;
  text-align: start;
}

.footer-logo-wrap {
  display: flex;
  justify-content: start;
}

.footer-logo {
  max-width: 100%;
  height: auto;
}

.footer-social {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  justify-content: start;
  margin-top: 1rem;
}

.footer-link {
  display: inline-block;
}

.footer-phone-link {
  direction: ltr;
  unicode-bidi: embed;
}

.footer-hr {
  border: 1px solid white;
  margin: 0;
}

.footer-copyright {
  text-align: center;
  color: white;
  margin: 1rem 0;
  padding: 0 8px;
}

.link {
  color: white !important;
}

.footer-btn {
  padding: 0.25rem !important;
}

.nav-item-link a {
  transition: 0.2s;
}

.nav-item-link a:hover {
  border-bottom: 5px solid #006633;
  text-decoration: unset;
}

.footer-dark {
  padding-top: 15px;
  text-align: center;
}

@media (max-width: 800px) {
  .nav-item-link {
    text-align: center;
    display: block;
  }
  .nav-item-link {
    margin-right: 0 !important;
  }

  .footer-logo-wrap {
    justify-content: center;
  }

  .footer-stack {
    text-align: center;
  }

  .footer-tagline-text {
    text-align: center;
  }

  .footer-social {
    justify-content: center;
  }
}
</style>
